import { createActions } from 'utils/redux';

export const { Types, Creators } = createActions({
  getCloseAccountStatus: [],
  closeAccount: ['data', 'action']
});
